// @ts-nocheck

import React, { useEffect, useRef } from 'react';
import Checklist from '@editorjs/checklist';
import CodeTool from '@editorjs/code';
import Delimiter from '@editorjs/delimiter';
import EditorJS from '@editorjs/editorjs';
import Header from '@editorjs/header';
import ImageTool from '@editorjs/image';
import InlineCode from '@editorjs/inline-code';
import LinkTool from '@editorjs/link';
import List from '@editorjs/list';
import Marker from '@editorjs/marker';
import Quote from '@editorjs/quote';
import Table from '@editorjs/table';
import Warning from '@editorjs/warning';
import styles from './RichTextEditor.module.css';

export const EDITOR_TOOLS = {
  header: {
    class: Header,
    config: {
      placeholder: 'Enter a header',
      levels: [1, 2, 3, 4, 5, 6],
      defaultLevel: 2,
    },
    shortcut: 'CMD+SHIFT+H',
    inlineToolbar: ['marker', 'inlineCode', 'link'],
  },
  paragraph: {
    inlineToolbar: ['marker', 'inlineCode', 'link'],
    config: {
      placeholder: 'Start typing here...',
    },
  },
  list: {
    class: List,
    inlineToolbar: ['marker', 'inlineCode', 'link'],
    config: {
      defaultStyle: 'unordered',
    },
  },
  checklist: {
    class: Checklist,
    inlineToolbar: ['marker', 'inlineCode', 'link'],
  },
  quote: {
    class: Quote,
    inlineToolbar: ['marker', 'inlineCode', 'link'],
    config: {
      quotePlaceholder: 'Enter a quote',
      captionPlaceholder: "Quote's author",
    },
    shortcut: 'CMD+SHIFT+O',
  },
  warning: {
    class: Warning,
    inlineToolbar: ['marker', 'inlineCode', 'link'],
    config: {
      titlePlaceholder: 'Title',
      messagePlaceholder: 'Message',
    },
  },
  marker: {
    class: Marker,
    shortcut: 'CMD+SHIFT+M',
  },
  code: {
    class: CodeTool,
    shortcut: 'CMD+SHIFT+C',
  },
  delimiter: {
    class: Delimiter,
  },
  inlineCode: {
    class: InlineCode,
    shortcut: 'CMD+SHIFT+`',
  },
  linkTool: {
    class: LinkTool,
    config: {
      endpoint: '/api/link',
    },
  },
  table: {
    class: Table,
    inlineToolbar: ['marker', 'inlineCode', 'link'],
    config: {
      rows: 2,
      cols: 3,
    },
  },
  image: {
    class: ImageTool,
    config: {
      endpoints: {
        byFile: '/api/uploadFile',
        byUrl: '/api/fetchUrl',
      },
      field: 'image',
      types: 'image/*',
    },
  },
};

const DEFAULT_INITIAL_DATA = {
  time: new Date().getTime(),
  blocks: [
    {
      id: 'header-block',
      type: 'header',
      data: {
        text: '',
        level: 2,
      },
    },
    {
      id: 'paragraph-block',
      type: 'paragraph',
      data: {
        text: '',
      },
    },
  ],
  version: '2.28.2',
};

const RichTextEditor = ({ onChange, data, readOnly = false }) => {
  const editorRef = useRef(null);
  const instanceRef = useRef(null);

  useEffect(() => {
    if (!instanceRef.current) {
      instanceRef.current = new EditorJS({
        holder: editorRef.current,
        tools: EDITOR_TOOLS,
        data: data || {},
        readOnly,
        placeholder: 'Start typing here...',
        defaultBlock: 'paragraph',
        // onReady: () => {
        //   // Force focus on the editor to show placeholders
        //   instanceRef.current.caret.setToBlock(0);
        //   instanceRef.current.caret.setToBlock(1);
        // },
        onChange: async () => {
          const content = await instanceRef.current.save();
          onChange?.(content);
        },
      });
    }

    return () => {
      if (instanceRef.current?.destroy) {
        instanceRef.current.destroy();
        instanceRef.current = null;
      }
    };
  }, []);

  return <div className={styles.select} ref={editorRef} />;
};

export default RichTextEditor;
